import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

const heroSlider = () => {
    const el = document.querySelector('.js-hero-swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Autoplay, EffectFade],
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        speed: 1000,
        allowTouchMove: false,
    });
};

export default heroSlider;
